import React from "react";


export const buttonStateClasses = isDisabled =>
    isDisabled ?
        "inline-flex text-white bg-blue-400 dark:bg-blue-500 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center" :
        "inline-flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"


export default ({caption, disabled, onClick, children}) =>
    <button
        type="button"
       className={buttonStateClasses(disabled)}
       disabled={disabled}
       onClick={onClick}
    >
        {children || caption}
    </button>